import styled from 'styled-components';
import { getTheme } from './theme';

export const StyledFormWrapper = styled.header`
  margin-bottom: 16px;
  > div:nth-child(3) {
    margin-top: 8px;
  }
`;

export const StyledRepositoryForm = styled.form`
  width: 100%;
  label {
    &.businessCase {
      text-align: center;
      .processus {
        color: ${getTheme().colors.primary.main};
      }
      .businessCaseItem {
        color: ${getTheme().colors.secondary.main};
      }
    }
  }
  input,
  textarea,
  .ant-select {
    width: 100%;
  }
  .formSection {
    margin-top: 24px;
  }
`;

export const StyledFormElems = styled.div`
  width: 100%;
  label {
    &.businessCase {
      text-align: center;
      .processus {
        color: ${getTheme().colors.primary.main};
      }
      .businessCaseItem {
        color: ${getTheme().colors.secondary.main};
      }
    }
  }
  input,
  textarea,
  .ant-select {
    width: 100%;
  }
  .formSection {
    margin-top: 24px;
  }
`;

export const StyledRepositoryFormButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;
`;

export const StyledFormBottomWrapper = styled.p`
  text-align: center;
  margin-top: 16px;
`;

export const StyledMainTitle = styled.h2<{ withMarginBottom?: boolean }>`
  color: ${getTheme().colors.primary.main};
  font-size: 1.6rem;
  font-weight: bold;
  ${({ withMarginBottom }) => !withMarginBottom && 'margin: 0'};
`;

export const StyledTableRepository = styled.div<{ isReasonTable?: boolean }>`
  .ant-table {
    border-left: 1px solid #000;
    border-right: 1px solid #000;
    border-top: 1px solid #000;
    thead th {
      border-right: 1px solid #000;
      position: relative;
      left: 1px;
      border-radius: 0 !important;
      &:nth-child(1),
      &:nth-child(2) {
        width: 200px;
      }
      &:nth-child(3) {
        width: ${(props) => (props.isReasonTable ? 'auto' : '200px')};
      }
    }
    tbody {
      table {
        border-collapse: separate;
      }
      tr {
        td:nth-child(1) {
          vertical-align: middle;
          border-bottom: 1px solid #000;
          text-align: center !important;
        }
      }
      .ant-table-cell {
        padding: 0 0 0 0px !important;
        border: none;
        vertical-align: top;
      }
      table.firstLevel,
      table.secondLevel {
        td {
          position: relative;
          padding: 0px 0 0 0px !important;
          text-align: left !important;
          height: 48px;
          border-collapse: collapse;
        }
      }
      table.firstLevel {
        td {
          border-left: 1px solid #000;
          border-bottom: none;
          border-top: none;
        }
      }
      table.secondLevel {
        td {
          border: none;
          border-bottom: 1px solid #000;
          padding-left: 8px !important;
        }
      }
      table.firstLevelOnly {
        td {
          border-bottom: 1px solid #000;
          padding-left: 8px !important;
        }
      }
    }
  }
`;

const StyledListWrapper = styled.div`
  padding: 16px;
`;
const StyledListTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;
const StyledListButtonWrapper = styled.div`
  margin-left: auto;
`;
const StyledListBodyWrapper = styled.div`
  margin: 4px 0 8px 0;
`;
const StyledListBoldWrapper = styled.span`
  font-weight: bold;
  margin-right: 4px;
`;

export const UnstyledButton = styled.button`
  font-size: 100%;
  border: 0;
  padding: 0;
  background-color: transparent;
  margin-right: 4px;
`;

export const StyledListUtil = {
  StyledListWrapper,
  StyledListTitleWrapper,
  StyledListButtonWrapper,
  StyledListBodyWrapper,
  StyledListBoldWrapper,
};

export const StyledBlueLink = styled.a<{ noDecoration?: boolean; backgroundColor?: string }>`
  display: flex;
  align-items: center;
  text-decoration: underline;
  font-size: 1.2rem;
  font-weight: bold;
  color: ${getTheme().colors.primary.main};
  ${(props) =>
    props.noDecoration &&
    `text-decoration: none;
    &:focus, &:hover, &:visited, &:link, &:active {
      text-decoration: none;
      cursor: pointer;
    }`};
  ${(props) => props.backgroundColor && `background-color: ${props.backgroundColor};`};
`;

export const StyledFormButtonWrapper = styled.div`
  display: flex;
  margin-top: 16px;
  > div:first-child {
    margin-right: 10px;
  }
`;
